import axios from "axios";
import URLTemplate from "url-template";

const defaultVerificationURL = "/access/validate/invite/{ws}/{email}/{token}";

const verificationURL = process.env.REACT_APP_AUTH_INVITE_VERIFICATION_URL
  ? URLTemplate.parse(process.env.REACT_APP_AUTH_INVITE_VERIFICATION_URL)
  : URLTemplate.parse(defaultVerificationURL);

/**
 *
 * @param {string} email
 * @param {string} ws
 * @param {string} token
 */
export const verify = (email, ws, token) =>
  axios.get(verificationURL.expand({ email, ws, token })).then(({ data }) => {
    return data.isValid ? Promise.resolve() : Promise.reject();
  });
